import _defineProperty from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
import { genOverflowStyle, getMultipleSelectorUnit } from '../../select/style/multiple';
import { mergeToken } from '../../theme/internal';
var genSize = function genSize(token, suffix) {
  var componentCls = token.componentCls,
    controlHeight = token.controlHeight;
  var suffixCls = suffix ? "".concat(componentCls, "-").concat(suffix) : '';
  var multipleSelectorUnit = getMultipleSelectorUnit(token);
  return [// genSelectionStyle(token, suffix),
  _defineProperty({}, "".concat(componentCls, "-multiple").concat(suffixCls), _defineProperty({
    paddingBlock: multipleSelectorUnit.containerPadding,
    paddingInlineStart: multipleSelectorUnit.basePadding,
    minHeight: controlHeight
  }, "".concat(componentCls, "-selection-item"), {
    height: multipleSelectorUnit.itemHeight,
    lineHeight: unit(multipleSelectorUnit.itemLineHeight)
  }))];
};
var genPickerMultipleStyle = function genPickerMultipleStyle(token) {
  var componentCls = token.componentCls,
    calc = token.calc,
    lineWidth = token.lineWidth;
  var smallToken = mergeToken(token, {
    fontHeight: token.fontSize,
    selectHeight: token.controlHeightSM,
    multipleSelectItemHeight: token.multipleItemHeightSM,
    borderRadius: token.borderRadiusSM,
    borderRadiusSM: token.borderRadiusXS,
    controlHeight: token.controlHeightSM
  });
  var largeToken = mergeToken(token, {
    fontHeight: calc(token.multipleItemHeightLG).sub(calc(lineWidth).mul(2).equal()).equal(),
    fontSize: token.fontSizeLG,
    selectHeight: token.controlHeightLG,
    multipleSelectItemHeight: token.multipleItemHeightLG,
    borderRadius: token.borderRadiusLG,
    borderRadiusSM: token.borderRadius,
    controlHeight: token.controlHeightLG
  });
  return [
  // ======================== Size ========================
  genSize(smallToken, 'small'), genSize(token), genSize(largeToken, 'large'), // ====================== Selection ======================
  _defineProperty({}, "".concat(componentCls).concat(componentCls, "-multiple"), Object.assign(Object.assign(_defineProperty({
    width: '100%',
    cursor: 'text'
  }, "".concat(componentCls, "-selector"), _defineProperty({
    flex: 'auto',
    padding: 0,
    position: 'relative',
    '&:after': {
      margin: 0
    }
  }, "".concat(componentCls, "-selection-placeholder"), {
    position: 'absolute',
    top: '50%',
    insetInlineStart: token.inputPaddingHorizontalBase,
    insetInlineEnd: 0,
    transform: 'translateY(-50%)',
    transition: "all ".concat(token.motionDurationSlow),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flex: 1,
    color: token.colorTextPlaceholder,
    pointerEvents: 'none'
  })), genOverflowStyle(token)), _defineProperty({}, "".concat(componentCls, "-multiple-input"), {
    width: 0,
    height: 0,
    border: 0,
    visibility: 'hidden',
    position: 'absolute',
    zIndex: -1
  })))];
};
export default genPickerMultipleStyle;